module.exports = __webpack_public_path__ + "static/media/Cabo-DROP-Fig8.5d5962de.png";